// extracted by mini-css-extract-plugin
export default {"page":"login_page__Cu4Ay","login-form":"login_login-form__AMe72"};